import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@weezevent/nacre';
import Styles from '../../../styles/minisite/blocks.module.css';
import { Trans } from 'react-i18next';
import { Loader } from 'semantic-ui-react';

export default function ContactBlock({ onClick }) {
    const [isLoading, setIsLoading] = React.useState(false);

    const handleClick = React.useCallback(() => {
        setIsLoading(true);
        onClick();
    }, [onClick]);

    return (
        <div className={`${Styles['create-content']} ${isLoading ? Styles['disabled-create-content'] : ''}`} onClick={handleClick}>
            {isLoading && <Loader inline active />}
            <Icon name="user" />
            <Trans i18nKey="ticket.event.minisite.block.add-block-contact" />
        </div>
    );
}

ContactBlock.propTypes = {
    onClick: PropTypes.func.isRequired
};
